import { RadioGroupField, TextField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EventFormColumns } from "./EventFormColumns";
import { EventTenantPlannedPersonCountField } from "./EventTenantPlannedPersonCountField";
import { useEventTypeField } from "./useEventTypeField";

export const EventParticipationStepFormFields: FC = () => {
	const { t } = useTranslation();
	const eventType = useEventTypeField();

	return (
		<>
			<EventFormColumns>
				{eventType?.participationPermissionRequirement !== "prohibited" && (
					<RadioGroupField
						required={eventType?.participationPermissionRequirement === "required"}
						label={t("Participation permission")}
						name="isInviteOnly"
						options={[
							{ name: t("All"), value: "false" },
							{
								name: t("Only with invitation"),
								value: "true",
							},
						]}
					/>
				)}
				{eventType?.linkToEventRequirement !== "prohibited" && (
					<TextField name="link" label={t("Event link")} required={eventType?.linkToEventRequirement === "required"} />
				)}
			</EventFormColumns>
			{eventType?.plannedPersonCountRequirement !== "prohibited" && <EventTenantPlannedPersonCountField />}
		</>
	);
};
